import { IconButton, Td, Tr } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { MdEdit } from 'react-icons/md';

import ColumnOptionsPropType from './ColumnOptionsPropType';
import EditableTableCell from './EditableTableCell';

function EditableTableRow(props) {
  const { i, columnOptions, rowOnClick, submitHandler, displayEditRowModal } = props;

  const [rowData, setRowData] = useState({ ...props.rowData });
  const [prevRowData, setPrevRowData] = useState({ ...props.rowData });

  useEffect(() => {
    setRowData({ ...props.rowData });
    setPrevRowData({ ...props.rowData });
  }, [props.rowData]);

  const onSubmit = async(data) => {
    return await submitHandler(data);
  };

  const row = columnOptions.map((options, i) => {
    const { key } = options;

    return (
      <EditableTableCell
        key={i}
        value={rowData?.[key]}
      />
    );
  });

  const isEmptyRowData = Object.keys(rowData).length === 0;
  const someColumEditable = columnOptions.some(option => option.editable(rowData, prevRowData));
  if (someColumEditable) {
    const controlCell = (
      <Td textAlign='center' padding={0} key={row.length}>
        {!isEmptyRowData && <IconButton onClick={() => displayEditRowModal(rowData, onSubmit)} size='sm' icon={<MdEdit color='#3483BE' size={18}/>} variant='ghost'/>}
      </Td>
    );
    row.push(controlCell);
  }

  return (
    <Tr
      onClick={rowOnClick?.(rowData)}
      cursor={!isEmptyRowData && rowOnClick && 'pointer'}
      h='48px'
      backgroundColor={i % 2 === 0 ? '#EDF2F7' : 'white'}
      _hover={{ background: '#ddd' }}
    >
      {row}
    </Tr>
  );
}

EditableTableRow.propTypes = {
  rowData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  columnOptions: ColumnOptionsPropType,
  refreshTableData: PropTypes.func,
  submitHandler: PropTypes.func,
  i: PropTypes.number,
  rowOnClick: PropTypes.func,
  displayEditRowModal: PropTypes.func.isRequired
};

EditableTableRow.defaultProps = {
  submitHandler: () => {}
};

export default EditableTableRow;
